<script setup lang="ts">
import IconBurger from '@/assets/icons/burger.svg'
import SearchPartnerBar from '@/components/features/partners/SearchPartnerBar.vue'
</script>

<template>
  <div
    class="lg:hidden fixed bottom-0 left-0 w-full bg-base-100 flex justify-between items-center p-4"
  >
    <SearchPartnerBar />
    <label for="my-drawer-2" class="btn btn-ghost drawer-button">
      <component :is="IconBurger" class="fill-current text-content" />
    </label>
  </div>
</template>
